export default __webpack_public_path__ + "static/media/GalanoGrotesque-Light.f6ebd29c.ttf";